import { useMemo } from "react";
import { useSessionContext } from "@/components/AuthModule/SessionContext";
import { exploreFurtherBanners, matchEligibility } from "@/utils/banners";

export const useExploreFurtherBanners = () => {
  const { sessionInfo } = useSessionContext();

  return useMemo(() => {
    const banners = exploreFurtherBanners;
    return banners.filter((banner) => {
      return matchEligibility(
        sessionInfo?.userDetails,
        banner.eligibilityPayloadMapping
      );
    });
  }, [sessionInfo?.userDetails]);
};
